import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import Drawer from '../../../../components/Drawer'
import ChangeHistory from '../../../../features/components/ChangeHistoryDrawer/ChangeHistory'

import useManageDrawer from '../../../../hooks/formHooks/useManageDrawer'

import { adsSelector } from '../../../../modules/selectors/ads'

import { CHANGE_ADS_HISTORY } from '../../../../constants/forms'
import { TYPE_AD } from '../../../../constants/changeHistory'

function AdsChangeHistory({ platform }) {
  const adsList = useSelector(adsSelector)
  const { isFormOpen, handleFormClose, selectedEditItemId } = useManageDrawer({ formName: CHANGE_ADS_HISTORY })

  const selectedAdData = useMemo(
    () => selectedEditItemId && adsList.find(({ id }) => id === selectedEditItemId),
    [selectedEditItemId, adsList]
  )
  const historyDrawerTitle = `Change History for '${selectedAdData?.name}'`

  return (
    <Drawer isOpen={isFormOpen} onClose={handleFormClose} title={historyDrawerTitle || 'Change History'}>
      <ChangeHistory historyType={TYPE_AD} platform={platform} itemId={selectedEditItemId} />
    </Drawer>
  )
}

AdsChangeHistory.propTypes = {
  platform: PropTypes.string.isRequired
}

export default AdsChangeHistory
